<template>
    <div
        class="rounded-muval-1 flex w-fit items-center"
        :class="sizeClasses"
    >
        <slot>Lozenge</slot>
    </div>
</template>
<script setup>
const props = defineProps({
    rounded: {
        type: Boolean,
        required: false,
        default: false,
    },
    size: {
        type: String,
        required: false,
        default: 'md',
    },
});

const sizeClasses = computed(() => {
    return {
        md: 'h-5 px-2 text-xs font-medium',
        lg: 'h-6 px-3 text-xs font-semibold',
    }[props.size];
});
</script>
